'use client'

import { useState } from 'react'
import { getMeProfileGetMeProfileQueryKey } from '@cocoonspace/api'
import { getGetMeProfileQueryKey } from '@cocoonspace/sdk-js/v2/domains/me-profile/me-profile'
import { Button } from '@cocoonspace/ui/components/button'
import {
	Dialog,
	DialogContent,
	DialogTrigger,
} from '@cocoonspace/ui/components/dialog'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@cocoonspace/ui/components/tooltip'
import { useLingui } from '@lingui/react/macro'
import { useQueryClient } from '@tanstack/react-query'
import { PencilIcon } from 'lucide-react'
import { useRouter } from 'next/navigation'

import { GeneralProfileInfoForm } from './general-profile-info-form'
import { UserProfileFormWrapper } from './use-profile-form.hook'

export const ProfileEditDialog = ({ icon = false }: { icon?: boolean }) => {
	const { t } = useLingui()
	const [isOpen, setIsOpen] = useState(false)
	const queryClient = useQueryClient()
	const router = useRouter()

	const trigger = (
		<DialogTrigger asChild>
			<Button
				variant={icon ? 'ghost' : 'outline'}
				size='sm'
				icon={icon}
				aria-label={icon ? t`Modifier` : undefined}
			>
				<PencilIcon />
				{icon ? null : t`Modifier`}
			</Button>
		</DialogTrigger>
	)

	return (
		<Dialog
			open={isOpen}
			onOpenChange={setIsOpen}
		>
			{icon ? (
				<Tooltip>
					<TooltipTrigger asChild>{trigger}</TooltipTrigger>
					<TooltipContent>{t`Modifier`}</TooltipContent>
				</Tooltip>
			) : (
				trigger
			)}

			<DialogContent className='max-h-[calc(100dvh-2rem)] overflow-y-auto p-0'>
				<UserProfileFormWrapper
					onSuccess={() => {
						const queryKeys = [
							getMeProfileGetMeProfileQueryKey(),
							getGetMeProfileQueryKey(),
						]

						queryKeys.map((queryKey) => {
							queryClient.invalidateQueries({ queryKey })
						})

						setIsOpen(false)
						router.refresh()
					}}
				>
					<GeneralProfileInfoForm />
				</UserProfileFormWrapper>
			</DialogContent>
		</Dialog>
	)
}
